module.exports = __webpack_public_path__ + "static/media/Jay Grossman.6d56fc6d.png";